import type { Sponsor } from '../types/showcase';

const up = 'https://buildersshowcaseofhomes.com/wp-content/uploads/2026/01';

export const presentingSponsor: Sponsor = {
  name: 'IncredibleBank',
  logo: `${up}/IB_Logo_1920x1080px-01-1024x576.jpg`,
};

export const advertisingSponsors: Sponsor[] = [
  { name: 'IncredibleBank', logo: `${up}/Incredible-Bank2-300x81.png` },
  { name: 'Print 1 Group', logo: `${up}/Print-1-Group.jpg` },
  { name: 'LMCU', logo: `${up}/LMCU-300x93.png` },
  { name: 'Garage Door Works', logo: `${up}/garage-door-works-300x87.png` },
  { name: 'HBK CPAs & Consultants', logo: `${up}/hbkcpasconsultants-300x76.jpg` },
  { name: 'Stokes', logo: `${up}/stokes-badge-blue-tagline-300x300.png` },
  { name: 'Williamson Bros. Inc.', logo: `${up}/WB-Williamson-Bros-Inc-300x257.png` },
];
